
export default
	props: block: Object

	computed:
		desktopImage: -> if @block.imageDesktop?.length then @block.imageDesktop else @block.imageMobile
		mobileImage: -> if @block.imageMobile?.length then @block.imageMobile else @block.imageDesktop

